import { useCallback } from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { COMMANDBAR_FILTER_TABS } from "../constants/common";
import { useGlobalCommandbarStore } from "../store";
import { CommandbarShortcutKeys } from "../types/common";

export const useChangeTabShortcut = () => {
  const activeFilterTab = useGlobalCommandbarStore(st => st.activeFilterTab);
  const setActiveFilterTab = useGlobalCommandbarStore(
    st => st.setActiveFilterTab,
  );
  const setShotcutKeysPressed = useGlobalCommandbarStore(
    st => st.setShotcutKeysPressed,
  );

  const getActiveTabIndex = useCallback(() => {
    return COMMANDBAR_FILTER_TABS.findIndex(
      tab => tab.label === activeFilterTab,
    );
  }, [activeFilterTab]);

  useHotkeys(
    "meta+[",
    () => {
      const activeTabIndex = getActiveTabIndex();
      const nextTabIndex =
        activeTabIndex === 0
          ? COMMANDBAR_FILTER_TABS.length - 1
          : activeTabIndex - 1;
      setActiveFilterTab(COMMANDBAR_FILTER_TABS[nextTabIndex].label);
      setShotcutKeysPressed([
        CommandbarShortcutKeys.META,
        CommandbarShortcutKeys.LEFT_SQUARE_BRACKET,
      ]);
    },
    { keydown: true, keyup: false },
  );

  useHotkeys(
    "meta+]",
    () => {
      const activeTabIndex = getActiveTabIndex();
      const nextTabIndex =
        activeTabIndex === COMMANDBAR_FILTER_TABS.length - 1
          ? 0
          : activeTabIndex + 1;
      setActiveFilterTab(COMMANDBAR_FILTER_TABS[nextTabIndex].label);
      setShotcutKeysPressed([
        CommandbarShortcutKeys.META,
        CommandbarShortcutKeys.RIGHT_SQUARE_BRACKET,
      ]);
    },
    { keydown: true, keyup: false },
  );
};
